module.exports = __webpack_public_path__ + "img/cu.4f192bed.jpg";